// import { Card, Col, Row, Tabs } from "antd";
// import React from "react";
// import { Navigate } from "react-router-dom";
// import checkTokenExp from "../../../utils/checkTokenExp";

// import BirthdayBar from "../../birthday/birthdayBar";
// import AttendancePopup from "../../UI/PopUp/AttendancePopup";
// import AnnouncementBar from "./AnnouncementBar";
// import DemoLine from "./Demoline";
// import PublicHolidayBar from "./PublicHolidayBar";

// const { TabPane } = Tabs;

// const Dashboard = () => {

//   const isLogged = Boolean(localStorage.getItem("isLogged"));
//   const compId = localStorage.getItem("company_id");


//   if (!isLogged) {
//     return <Navigate to={"/admin/auth/login"} replace={true} />;
//   }

//   // Logging Out if token is expired
//   const accessToken = localStorage.getItem("access-token");
//   checkTokenExp(accessToken);

//   // Get the roleId
//   const roleId = parseInt(localStorage.getItem("roleId"), 10);
//   //   console.log("roleId: ",roleId)

//   return (
//     <>
//       <div>
//         <Row gutter={[30, 30]} justify={"space-between"}>
//           <Col sm={24} md={24} lg={12} span={24} className="mb-auto">

//           </Col>
//           <Col sm={24} md={24} lg={12} span={24}>
//             <div className="text-end mr-4">
//               <AttendancePopup />
//             </div>
//           </Col>
//         </Row>

//         <section className='mt-5 mb-5'>

//           <div>
//             {roleId == 1 && (
//               <div className="mb-3">
//                 <Row>
//                   <Col span={24}>
//                     <DemoLine />
//                   </Col>
//                 </Row>
//               </div>
//             )}
//             <div>
//               <Row gutter={[30, 30]}>
//                 <Col sm={24} md={24} lg={12} span={24} className="mb-auto">
//                   <Card title="PUBLIC HOLIDAYS" className="">
//                     <PublicHolidayBar />
//                   </Card>
//                 </Col>


//                 <Col sm={24} md={24} lg={12} span={24}>
//                   {/* <Card title="Announcements & Birthdays"> */}
//                   <Card>
//                     <Tabs defaultActiveKey="1">
//                       <TabPane tab="Announcements" key="1">
//                         <AnnouncementBar />
//                       </TabPane>
//                       <TabPane tab="Today's Birthdays" key="2">
//                         <BirthdayBar />
//                       </TabPane>
//                     </Tabs>
//                   </Card>
//                 </Col>
//               </Row>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default Dashboard;

import { Card, Col, Row, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import checkTokenExp from "../../../utils/checkTokenExp";
import BirthdayBar from "../../birthday/birthdayBar";
import AttendancePopup from "../../UI/PopUp/AttendancePopup";
import AnnouncementBar from "./AnnouncementBar";

import ChangePassword from "../../user/changePassword";
import DemoLine from "./Demoline";
import PublicHolidayBar from "./PublicHolidayBar";

const { TabPane } = Tabs;

const Dashboard = () => {
  const [passwordModalVisible, setPasswordModalVisible] = useState(false);
  const [dashboardVisible, setDashboardVisible] = useState(false);
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const requirePasswordChange = localStorage.getItem("requirePasswordChange");
  console.log("passwordChanged", requirePasswordChange);

  useEffect(() => {
    // Check if password needs to be changed
    if (requirePasswordChange === 'true' || !requirePasswordChange) {
      setPasswordModalVisible(true);
      setDashboardVisible(false);
    } else {
      setDashboardVisible(true);
    }
  }, [requirePasswordChange]);

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }

  const accessToken = localStorage.getItem("access-token");
  checkTokenExp(accessToken);

  const roleId = parseInt(localStorage.getItem("roleId"), 10);

  const handlePasswordChange = () => {
    setPasswordModalVisible(false);
    setDashboardVisible(true);
  };

  if (!dashboardVisible) {
    return (
      <ChangePassword
        visible={passwordModalVisible}
        onCancel={handlePasswordChange}
      />
    );
  }

  return (
    <div>
      <Row gutter={[30, 30]} justify={"space-between"}>
        <Col sm={24} md={24} lg={12} span={24} className="mb-auto">
        </Col>
        <Col sm={24} md={24} lg={12} span={24}>
          <div className="text-end mr-4">
            <AttendancePopup />
          </div>
        </Col>
      </Row>

      <section className='mt-5 mb-5'>
        <div>
          {roleId === 1 && (
            <div className="mb-3">
              <Row>
                <Col span={24}>
                  <DemoLine />
                </Col>
              </Row>
            </div>
          )}
          <div>
            <Row gutter={[30, 30]}>
              <Col sm={24} md={24} lg={12} span={24} className="mb-auto">
                <Card title="PUBLIC HOLIDAYS" className="">
                  <PublicHolidayBar />
                </Card>
              </Col>

              <Col sm={24} md={24} lg={12} span={24}>
                <Card>
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Announcements" key="1">
                      <AnnouncementBar />
                    </TabPane>
                    <TabPane tab="Today's Birthdays" key="2">
                      <BirthdayBar />
                    </TabPane>
                  </Tabs>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
